import { logEvent } from "firebase/analytics";
import { analytics } from "../../config/firebaseConfig";

export const GAEventTrack = ({ event, data = {} }) => {
  // 1. Log to Firebase Analytics
  try {
    logEvent(analytics, event, { ...data });
  } catch (err) {
    console.error("Firebase Analytics logEvent error:", err);
  }

  // 2. Log directly to GA4 stream via window.gtag / dataLayer
  try {
    if (window.gtag) {
      window.gtag("event", event, data);
    } else {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: event,
        ...data
      });
    }
  } catch (err) {
    console.error("GA4 gtag event track error:", err);
  }
};
